import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
// import Sidebar from "../../../Sidebar/Sidebar"
import NewExamSheetComp from "./Component/NewExamSheetComp"

const NewExamSheet = () => {
    return (
        <>
            <Navbar />
            <div className="d-flex mainContentArea">
                {/* <Sidebar /> */}
                <NewExamSheetComp />
            </div>
            <Footer />
        </>
    )
}

export default NewExamSheet